<template>
  <div>
    <rest-form-item :label="$t('ChannelConfig_Mitto_ApiKey')" prop="access_key">
      <el-input
        v-model="model.params.api_key"
        :placeholder="$t('ChannelConfig_Mitto_ApiKey_Placeholder')"
      />
    </rest-form-item>
  </div>
</template>

<script>
import RestFormItem from '@/common/components/rest/RestFormItem'

export default {
  components: { RestFormItem },
  props: {
    model: {
      type: Object,
      required: true
    }
  },

  created() {
    if (!this.$route.query.id) {
      this.$set(this.model, 'type', 'sms')
      this.$set(this.model, 'channel', 'mitto')
      this.$set(this.model, 'params', {})
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/modules/channels/providers/Mitto.vue